import { render } from "./editDeckDocument.vue?vue&type=template&id=4e66d782&scoped=true"
import script from "./editDeckDocument.vue?vue&type=script&lang=js"
export * from "./editDeckDocument.vue?vue&type=script&lang=js"

import "./editDeckDocument.vue?vue&type=style&index=0&id=4e66d782&scoped=true&lang=css"

import exportComponent from "E:\\workspace2017\\vue3.0\\premia-user-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e66d782"]])

export default __exports__